module.exports = __webpack_public_path__ + "static/predictivepoem 41-01-5baae590e4586041f3b86a81caf4a956.jpg";